module.exports = __webpack_public_path__ + "static/assets/8e5642d75fe0df498402f7ed04775695.svg";